module.exports = __webpack_public_path__ + "static/sport/bgi.d31dc17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/trea/bgi.jpg
// module id = wdL5
// module chunks = 0